import {Col, Image, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import React, {useEffect, useState} from "react";
import API from "../api/api";
import {Link} from "react-router-dom";
import ProfileIcon from "../components/ProfileIcon";

function Home() {
    const [teamMembers, setTeamMembers] = useState(["ldkfjasd", "jdf;alkd"])

    useEffect(() => {
        API.get("/users/team-members").then((response) => {
            setTeamMembers(response.data)
        });
    }, []);

    return (
        <Container>
            <div className="bg-gradient-dark text-white">
                <div>
                    <div>
                        <h1 className="text-center h1 display-1 p-5">Welcome to Milky Way Trail</h1>
                        <p className="display-6">Where the stars align to create unforgettable gaming
                            experiences!</p>
                        <div>
                            <p>Our mission at Milky Way Trail is simple yet ambitious: to
                                transport you to
                                galaxies of entertainment
                                and
                                excitement through the power of game development. We are a passionate team of
                                visionaries,
                                dreamers,
                                and
                                creators dedicated to crafting immersive and captivating games that will take you on a
                                journey
                                beyond
                                your
                                wildest imagination.</p>
                        </div>
                    </div>

                    <div>
                        <h2 className="text-center h2 mt-5">Our Mission</h2>
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <Image
                                    src="https://storage.googleapis.com/milky-way-trail-website-data/random_image_storage/galaxy-gif.gif"
                                    className="general-pic-left"
                                    fluid
                                />
                            </Col>
                            <Col className="d-flex align-items-center">
                                <p>At Milky Way Trail, we understand that gaming is not
                                    just a
                                    pastime; it's
                                    an art form that has the
                                    potential
                                    to ignite emotions, spark creativity, and forge connections with players worldwide.
                                    With
                                    this belief
                                    at
                                    our
                                    core, we embark on a mission to provide you, our valued users, with nothing but the
                                    best.
                                    Our
                                    commitment
                                    to
                                    excellence, innovation, and the pursuit of fun is what sets us apart in the gaming
                                    industry.</p>
                            </Col>
                        </Row>
                    </div>

                    <div>
                        <h2 className="text-center h2 mt-5">Our Projects</h2>
                        <Row>
                            <Col className="d-flex align-items-center">
                                <p>With every project we undertake, we aim to push the
                                    boundaries
                                    of what's
                                    possible, delivering games
                                    that
                                    transcend genres, blend storytelling with gameplay, and leave you craving for more.
                                    Whether
                                    you're a
                                    casual
                                    gamer, a dedicated enthusiast, or a seasoned pro, Milky Way Trail welcomes you to
                                    embark
                                    on
                                    a cosmic
                                    journey
                                    through the universe of gaming.</p>
                            </Col>
                            <Col className="d-flex justify-content-center">
                                <Image
                                    src="https://storage.googleapis.com/milky-way-trail-website-data/random_image_storage/gaming-gif-1.gif"
                                    className="general-pic-right" fluid/>
                            </Col>
                        </Row>
                    </div>

                    <div>
                        <h2 className="text-center h2 mt-5">Join the Adventure</h2>
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <Image
                                    src="https://storage.googleapis.com/milky-way-trail-website-data/random_image_storage/gaming-gif-2.gif"
                                    className="general-pic-left" fluid/>
                            </Col>
                            <Col className="d-flex align-items-center">
                                <p>Join us on this adventure, where the Milky Way becomes
                                    your
                                    playground, and
                                    the stars light up to
                                    guide
                                    you
                                    through a galaxy of thrilling and immersive gaming experiences. Together, let's
                                    explore
                                    new
                                    frontiers,
                                    create lasting memories, and unlock the infinite potential of gaming. Welcome to
                                    Milky
                                    Way
                                    Trail –
                                    where
                                    gaming meets the cosmos!</p>
                            </Col>
                        </Row>
                    </div>
                </div>

                <h2 className="text-center h2 m-5">Meet The Team:</h2>
                <Container>
                    <Row className="justify-content-center">
                        {teamMembers.map((member, i) => (
                            <Col key={i} md={6} lg={4} xl={3} className="text-center mb-4">
                                <div className="developer-profile">
                                    <ProfileIcon {...member} />
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
        </Container>
    );
}

export default Home;
